import React, { useEffect, useState } from 'react';
import './App.css';
import axios from 'axios';

function App() {


  const [dados, setDados] = useState([]);

    useEffect(init, []);

    async function init() {
        const res = await Promise.resolve(axios.get(`http://127.0.0.1:8000/api/employeer/`));
        console.log(res.data);
        setDados(res.data);
    }

  return (
    <div className="App">
      {dados}
    </div>
  );
}

export default App;